import { providerLogger } from '@ragu-components/logger';
import { buildUrl, maybeThrowHttpError, validateStatus } from '@ragu-components/ord-providers';

import type { CallRecordingConfBulkReplaceQueues } from '@ragu-components/ord-types';
import type { AxiosInstance } from 'axios';

export const replaceCallRecordingConfQueues = async (
  axiosInstance: AxiosInstance,
  realmId: string,
  confId: string,
  queueIds: string[]
): Promise<void> => {
  providerLogger.debug('replaceCallRecordingConfQueues', confId, queueIds);
  const url = buildUrl('queues', { realmId, parentResource: 'call_recording_confs', parentId: confId });
  const body: CallRecordingConfBulkReplaceQueues = { queues: queueIds };
  const response = await axiosInstance.put(url, body, { validateStatus });
  maybeThrowHttpError(response);
};
